import storage from '@/shared/storage'
import {Commit} from 'vuex'

interface AccountStruct {
  platform: number
  requestId: number
  userId: string
  syncTimeStamp: number
  token: string
  orgId: number
}

interface PermissionStruct {
  roleId: number
  super: boolean
  list: {
    menuId: number
    op: number
  }[]
}

interface Role {
  admin: 0 | 1
  default: boolean
  desc: string
  name: string
  roleId: number

  /**
   * 场景: 用法不明.??
   */
  scene: string
  permission: {
    super: boolean
    list: {
      menuId: number
      op: number
    }[]
  }
}

interface UserStruct {
  userId: string
  name: string
  mobilePhone: string
  orgId: number
  orgName: string
  status: number
  appoint: number
  role: Role
}

interface LoginInfo {
  account: AccountStruct
  permission: PermissionStruct
  user: UserStruct
}

interface Counselor {
  userId: number
  name: string
}

type Map = {
  [key: string]: any
  [index: number]: any
}

interface State {
  account: AccountStruct
  permission: PermissionStruct
  user: UserStruct
  counselors: Counselor[]
  counselorsMap: Map
}

export default {
  state: {
    account: storage.get('account') || {},
    permission: storage.get('permission') || {},
    user: storage.get('user') || {},
    counselors: storage.get('counselors') || [],
    counselorsMap: storage.get('counselorsMap') || {},
  },
  getters: {
    getAccount(state: { commit: Commit; account: AccountStruct }) {
      // 用户通过account.token判断是否登录
      return state.account || storage.get('account')
    },
    isHasAppointPermission(state: State): boolean {
      return state.user?.appoint === 1
    },
    /**
     * 用户是否属于普通管理员.
     */
    isAdmin(state: State): boolean {
      return !!state.user?.role?.admin
    },
    /**
     * 用户是否属于超级管理员.
     */
    isSuperAdmin(state: State): boolean {
      return !!state.permission?.super
    },
    getUser(state: State) {
      return state.user || storage.get('user')
    },
    getCounselorById(state: State) {
      return (id: number) => {
        return state.counselorsMap[id]
      }
    },
    getCounselors(state: State) {
      return state.counselors
    },
  },
  mutations: {
    clearLoginInfo(state: State) {
      state.account = {} as AccountStruct
      state.permission = {} as PermissionStruct
      state.user = {} as UserStruct
      storage.delete('account')
      storage.delete('permission')
      storage.delete('user')
      storage.delete('counselors')
      storage.delete('counselorsMap')
    },
    setCoverAccount(state: State, payload: Partial<AccountStruct>) {
      if (!payload) return
      state.account = {...state.account, ...payload}

    },
    setAccount(state: State, payload: AccountStruct) {
      if (!payload) return
      state.account = payload
    },
    setPermission(state: State, payload: PermissionStruct) {
      if (!payload) return
      state.permission = payload
    },
    setUser(state: State, payload: UserStruct) {
      if (!payload) return
      state.user = payload
    },
    setLoginInfo(state: State, payload: LoginInfo) {
      const {account, permission, user} = payload
      if (account) state.account = account
      if (permission) state.permission = permission
      if (user) state.user = user
    },
    setCounselors(state: State, payload: Counselor[]) {
      state.counselors = payload
    },
    setCounselorsMap(state: State, payload: Map) {
      state.counselorsMap = payload
    },
  },
}
